import { useTheme, Box } from "@mui/material";
import styled from "@emotion/styled";

const FooterStyled = styled('footer')(({ theme }) => ({
    position: 'relative',
    ul: {
        li: {
            position: 'relative',
            '&:after': {
                content: '""',
                height: '100%',
                position: 'absolute',
                right: '-7px',
                top: 0,
                width: '2px',
                background: theme.palette.mode === 'dark'
                    ? '#323232'
                    : '#f2f2f2'
            },
        },
    },
}));

export default function Footer() {
    const theme = useTheme();

    return (
        <FooterStyled style={{ backgroundColor: theme.palette.secondary.main }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 auto' }}>
                <ul>
                    <li>
                        <a
                            href="http://fao.org/contact-us/en/"
                            target="_blank"
                            rel="noreferrer"
                        >Contact us</a
                        >
                    </li>
                    <li>
                        <a
                            href="http://fao.org/contact-us/terms/en/"
                            target="_blank"
                            rel="noreferrer"
                        >Terms and Conditions</a
                        >
                    </li>
                    <li>
                        <a
                            href="http://fao.org/contact-us/data-protection-and-privacy/en/"
                            target="_blank"
                            rel="noreferrer"
                        >Data protection and privacy</a
                        >
                    </li>
                    <li>
                        <a
                            href="http://fao.org/contact-us/scam-alert/en/"
                            target="_blank"
                            rel="noreferrer"
                        >Scam Alert</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://www.fao.org/aud/69204/en"
                            target="_blank"
                            rel="noreferrer"
                        >Report Misconduct</a
                        >
                    </li>
                </ul>
                <a
                    style={{ color: theme.palette.primary.fontColor, fontSize: '13px' }}
                    href="https://www.fao.org/contact-us/terms/en/"
                    target="_blank"
                    rel="noreferrer"
                >© FAO&nbsp;{(new Date().getFullYear())}</a>
            </Box>
        </FooterStyled>
    )
}